import { Close } from "@mui/icons-material";
import { ClickAwayListener, TooltipProps } from "@mui/material";
import { FC, useState } from "react";
import { COLORS } from "../../../styles/constants.style";
import { MuiBox } from "../../box/MuiBox";
import { NotesIcon } from "../../notesIcon/NotesIcon";
import { MuiTypography } from "../../typography/MuiTypography";
import { MuiStyledTooltip } from "../MuiToolTip.style";
import { MuiNotesToolTipWrapper } from "./MuiNotesToolTip.style";
import { EMPTY_VALUE_DASH } from "../../../helpers/constants/common";
import { isEmpty, isNotEmpty } from "../../../helpers/utils";

type MuiNotesToolTipProps = {
  message: string;
  placement?: TooltipProps["placement"];
};

export const MuiNotesToolTip: FC<MuiNotesToolTipProps> = ({
  message,
  placement = "bottom-start",
}) => {
  const [showToolTip, setShowToolTip] = useState(false);

  const handleToolTipClose = () => {
    if (showToolTip) {
      setShowToolTip(false);
    }
  };

  const toggleToolTip = () => {
    setShowToolTip(true);
  };

  const hasMessage = isNotEmpty(message);

  return (
    <ClickAwayListener onClickAway={() => setShowToolTip(false)}>
      <MuiNotesToolTipWrapper>
        {hasMessage ? (
          <MuiStyledTooltip
            PopperProps={{
              disablePortal: true, // Important for ClickAwayListener to work correctly
            }}
            toolTipBgColor={COLORS.cirrus_black1}
            textColor={COLORS.cirrus_black}
            arrowBgColor={COLORS.cirrus_black6}
            borderWidth={"1px"}
            maxWidth="650px"
            placement={placement}
            tabIndex={0}
            title={
              <MuiBox className="tooltip-content">
                <Close onClick={handleToolTipClose} />
                <MuiTypography variant={"h3"}>{message}</MuiTypography>
              </MuiBox>
            }
            open={showToolTip}
          >
            <NotesIcon onToggleToolTip={toggleToolTip} />
          </MuiStyledTooltip>
        ) : (
          <MuiTypography variant={"h3"}>{EMPTY_VALUE_DASH}</MuiTypography>
        )}
      </MuiNotesToolTipWrapper>
    </ClickAwayListener>
  );
};
